type StoreActionMeta<T = unknown> = {
  optimist?: boolean;
  promise?: Promise<T>;
  tracking?: unknown;
  redirect_uri?: string;
  [key: string]: unknown;
};

function createAction<P>(
  type: string,
  payload?: P,
  meta: StoreActionMeta = {},
): Action<P> & { meta?: StoreActionMeta } {
  return {
    type,
    ...(payload !== undefined ? { payload } : {}),
    meta,
  } as Action<P> & { meta?: StoreActionMeta };
}

function createOptimisticAction<P, T>(
  type: string,
  payload: P | undefined,
  meta: StoreActionMeta<T>,
): Action<P> & { meta: StoreActionMeta<T> } {
  return {
    type,
    ...(payload ? { payload } : null),
    meta,
  } as Action<P> & { meta: StoreActionMeta<T> };
}

export type { StoreActionMeta };
export { createOptimisticAction };

/** Dispatches an optimistic action; types the promise returned by redux-optimist-promise. */
export function dispatchOptimistic<T>(
  dispatch: ReduxDispatch,
  action:
    | (Action<unknown> & { meta?: { promise?: Promise<T> } })
    | ((dispatch: ReduxDispatch, getState?: GetReduxState) => unknown),
): Promise<T> {
  return dispatch(action as Parameters<ReduxDispatch>[0]) as unknown as Promise<T>;
}

export default createAction;
